import { BriefClassificationResponse } from '../../../api';
import { BuyerBriefOverviewResponse, SectionsApiResponse } from '../../useEnrichedBuyerBrief/types';
import { transformFreelancerPreferences } from '../../useEnrichedBuyerBrief/utils/transformFreelancerPreferences';

export interface BuildBriefClassificationParams {
    brief: BuyerBriefOverviewResponse;
    sectionApi: SectionsApiResponse;
}

/**
 * Builds a BriefClassificationResponse object from brief and section API data
 * Used when duplicating a brief to reconstruct the classification data
 */
export const buildBriefClassification = ({
    brief,
    sectionApi,
}: BuildBriefClassificationParams): BriefClassificationResponse => ({
    context_id: brief.contextId ?? '',
    leaf_classification: [
        {
            category_id: brief.categoryId ?? 0,
            sub_category_id: brief.subCategoryId ?? 0,
            nested_sub_category_id: brief.nestedSubCategoryId ?? brief.subCategoryId ?? 0,
            display_name: brief.categoryName ?? brief.title ?? '',
            explainer: brief.description ?? '',
        },
    ],
    static_data: {
        ...sectionApi,
        budget: sectionApi.budget_config,
    },
    resolved_data: {
        need_type: {
            ...(brief.needType && { needType: brief.needType }),
            ongoingWorkPotential: brief.needTypeDetails?.ongoingWorkPotential ?? false,
        },

        budget: {
            min_price_in_cents: brief.budgetRangeInCents?.min ?? brief.budgetInCents,
            max_price_in_cents: brief.budgetRangeInCents?.max ?? brief.budgetInCents,
            pricing_type: brief.pricingType,
        },
        delivery_time: {
            timeline: brief.timeline,
            delivery_date: brief.deliveryDate ? String(brief.deliveryDate) : '',
            timeline_details: brief.timelineDetails,
        },
        metadata: {
            filters:
                brief.metadataAnswers?.serviceOptions?.reduce<Record<string, string[]>>((acc, opt) => {
                    acc[opt.key] = opt.values;
                    return acc;
                }, {}) ?? {},
        },
        freelancer_preferences: transformFreelancerPreferences(brief.metadataAnswers?.freelancerPreferences),
        query_string: '',
    },
});
